import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const TasApprovableSchema = withDefaults({
  type: 'tas-approvable',
  objectExtensions: ['tas-approvable'],
  fields: [
    {
      kind: 'attribute',
      name: 'approval',
    },
    {
      kind: 'attribute',
      name: 'state',
    },
    {
      kind: 'attribute',
      name: 'dataState',
    },
    {
      kind: 'attribute',
      name: 'transitionLog',
    },
    {
      kind: 'attribute',
      name: 'affirmed',
    },
    {
      kind: 'attribute',
      name: 'currentReviewers',
    },
    {
      kind: 'attribute',
      name: 'possibleReviewers',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'attribute',
      name: 'createdBy',
    },
    {
      kind: 'attribute',
      name: 'updatedBy',
    },
    {
      kind: 'belongsTo',
      name: 'approvable',
      type: '',
      options: {
        async: false,
        inverse: null,
        polymorphic: true,
      },
    },
    {
      kind: 'belongsTo',
      name: 'inContext',
      type: '',
      options: {
        async: false,
        inverse: null,
        polymorphic: true,
      },
    },
    {
      kind: 'belongsTo',
      name: 'company',
      type: 'company',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'person',
      type: 'person',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default TasApprovableSchema;
